import { Environments } from 'constants/environments';

const rawEnv = process.env.NEXT_PUBLIC_ENV ?? process.env.REACT_APP_ENV;

export const getAppEnvironment = (): Environments => {
  const raw = rawEnv?.toLowerCase();
  switch (raw) {
    case Environments.LOCAL: return Environments.LOCAL;
    case Environments.TEST: return Environments.TEST;
    case Environments.DEVELOPMENT: return Environments.DEVELOPMENT;
    case Environments.UAT: return Environments.UAT;
    case Environments.PRODUCTION: return Environments.PRODUCTION;
    default:
      return Environments.DEVELOPMENT;
  }
};
